import React from "react";
import { useNavigate } from "react-router-dom";
import "../Booking/Booking.css";

const Booking = () => {
  const navigate = useNavigate();

  return (
    <section className="booking-section-b">
      <div className="booking-content-b">
        <p className="booking-quote-b">
          “Every journey begins with a single click.”
        </p>

        <h1 className="booking-title-b">
          Flight Booking Page <span>Coming Soon</span>
        </h1>

        <button
          className="booking-btn-b"
          onClick={() => navigate("/")}
        >
          Go Back Home
        </button>
      </div>
    </section>
  );
};

export default Booking;
